import { createContext } from 'react';

export const memberContext = createContext({});

export default memberContext;
